
export default {
  name: 'MoleculeContentBlockIframe',
  props: {
    contentBlock: {
      required: true,
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
